<template>
  <div class="content">
    <b-card>
      <b-row>
        <b-col>
          <b-img v-bind:src="acmmm19_img" width="400" alt="placeholder" lg="5"></b-img>
        </b-col>
        <b-col md="12" lg="7">
          Z. Shen, S. Fan, Y. Wong, T.-T. Ng and M. Kankanhalli, "Human-imperceptible Privacy Protection Against Machines". ACM Multimedia Conference (ACMMM), 2019. [<a href="https://ncript.comp.nus.edu.sg/site/nus-files/visual-privacy/ZhiqiACMMM2019-camera ready-v6.pdf">pdf</a>](<span style='color:red;'>Oral, Best Student Paper</span>)
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'Publication',
  data(){
    return {
      acmmm19_img: require('../assets/ACMMM-2019.png')
    }
  },
  components:{
  }
}
</script>

<style scoped>

</style>
